export default __webpack_public_path__ + "static/media/water.15f06e05.svg";